import { useEffect } from "react";

const useScript = (url) => {
  let loaded = false;
  useEffect(() => {
    if (loaded) return;
    loaded = true;
    const script = document.createElement("script");

    script.src = url;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url]);
};

export default useScript;
